import React from 'react'
import { useEffect } from 'react';
import { Link } from 'react-router-dom'
import { ProductosListar } from './ProductosListar';
export const PaginasWeb = ({ productos, getProductos, getIdProducto1, productosCategorias, getCategoria, categoria, setMiCarrito, moneda, setMoneda, dolarMep, precioPlan1, precioPlan2, precioPlan3, formatoPrecio }) => {

    useEffect(() => {
        window.scrollTo(0, 0);
        console.log("<--- 1 vez cunando entra")
    }, []); // <--- 1 vez cunando entra

    return (




        precioPlan2 !== false &&
        <ProductosListar productos={productos} getProductos={getProductos} getIdProducto1={getIdProducto1} getCategoria={getCategoria} setMiCarrito={setMiCarrito} moneda={moneda} setMoneda={setMoneda} dolarMep={dolarMep} precioPlan1={precioPlan1} precioPlan2={precioPlan2} precioPlan3={precioPlan3} formatoPrecio={formatoPrecio} />




    )
}